export default "__VITE_PUBLIC_ASSET__b9f41287__"